import { createContext, PropsWithChildren } from 'react';
import { usePermissionDeniedManager } from '@/providers/PermissionDeniedProvider/PermissionDeniedContext.hooks';
import { IPermissionDeniedContext } from '@/providers/PermissionDeniedProvider/PermissionDeniedContext.types';

export const PermissionDeniedContext = createContext<Partial<IPermissionDeniedContext>>({});

export const PermissionDeniedProvider = ({ children }: PropsWithChildren) => {
  const value = usePermissionDeniedManager();

  return (
    <PermissionDeniedContext.Provider value={value}>{children}</PermissionDeniedContext.Provider>
  );
};
